module.exports = __webpack_public_path__ + "img/ic_google.d02ef725.png";